import React from "react";
import LycaSimBanner from "../../reusable/LycaSimBanner";
import BuySimMain from "./BuySimMain";
import BuySimSubNavi from "../../reusable/BuySimSubNavi";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import AnyQuestions from "../../reusable/AnyQuestions";

class BuySim extends React.Component {
  render() {
    return (
      <div>
        <LycaSimBanner />
        <BuySimSubNavi />
        <BuySimMain />
        <AnyQuestions />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(BuySim);



// WEBPACK FOOTER //
// ./src/pages/buysim/index.js